import * as Sentry from "@sentry/browser";
import { BrowserTracing } from '@sentry/browser'
import { createRoot } from "react-dom/client";

import React from "react";
import App from "./App";

import "./i18n";
import { getInstance } from "./utils/utils";
import { Instance, isDevelopment } from "./const/consts";

const instance = getInstance();

if (process.env.NODE_ENV === 'production' && (instance === Instance.RU || isDevelopment)) {
  Sentry.init({
    integrations: [new BrowserTracing()],
    dsn: process.env.REACT_APP_SENTRY_DSN_RU,
    environment: process.env.REACT_APP_SENTRY_ENV,
  });
}

const domNode = document.getElementById("root");
const root = createRoot(domNode);

root.render(<App />);
